import _regeneratorRuntime from "@babel/runtime/regenerator";

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable no-debugger */
import window from '../sdk/windowWrapper';
import Consts from '../utils/consts';

var AppSettings = /*#__PURE__*/function () {
  function AppSettings(compId, instance, viewMode, baseUrl) {
    if (compId === void 0) {
      compId = undefined;
    }

    if (instance === void 0) {
      instance = undefined;
    }

    if (viewMode === void 0) {
      viewMode = undefined;
    }

    if (baseUrl === void 0) {
      baseUrl = undefined;
    }

    this.compId = compId;
    this.instance = instance;
    this.getCompId = this.getCompId.bind(this);
    this.getInstance = this.getInstance.bind(this);
    this.viewMode = viewMode;
    this.baseUrl = baseUrl || '';
  }

  var _proto = AppSettings.prototype;

  _proto.getCompId = function getCompId() {
    if (this.compId) {
      return this.compId;
    }

    return window.Wix.Utils.getOrigCompId() ? window.Wix.Utils.getOrigCompId() : window.Wix.Utils.getCompId();
  };

  _proto.isLiveSite = function isLiveSite() {
    return this.viewMode && this.viewMode.toLowerCase() === 'site';
  };

  _proto.isPreview = function isPreview() {
    return this.viewMode && this.viewMode.toLowerCase() === 'preview';
  };

  _proto.getInstance = function getInstance() {
    return this.instance ? this.instance : window.instance;
  };

  _proto.get = /*#__PURE__*/function () {
    var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, key) {
      var host, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              host = 'VIEWER';
              _context.next = 3;
              return fetch(this.baseUrl + "/_api/app-settings-service/v1/settings/components/" + this.getCompId() + "?state=" + state + "&host=" + host, {
                method: 'GET',
                headers: {
                  Authorization: this.getInstance(),
                  Accept: 'application/json, text/plain, */*'
                }
              }).then(function (res) {
                return res.json();
              });

            case 3:
              response = _context.sent;

              if (!(response && response.settings)) {
                _context.next = 14;
                break;
              }

              if (!response.settings.originGallerySettings) {
                _context.next = 11;
                break;
              }

              response.settings = _objectSpread(_objectSpread({}, response.settings.originGallerySettings), response.settings);
              response.settings.originGallerySettings = null;

              if (!(!this.isLiveSite() && !this.isPreview())) {
                _context.next = 11;
                break;
              }

              _context.next = 11;
              return this.setMultiple(response.settings, Consts.dataSavedState.PUBLISHED);

            case 11:
              if (!key) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return", response.settings[key]);

            case 13:
              return _context.abrupt("return", response.settings);

            case 14:
              return _context.abrupt("return", undefined);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function get(_x, _x2) {
      return _get.apply(this, arguments);
    }

    return get;
  }();

  _proto.setMultiple = /*#__PURE__*/function () {
    var _setMultiple = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(settingObject, state) {
      var galleryId, neededSettings, host, settings, data;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (state === void 0) {
                state = Consts.dataSavedState.SAVED;
              }

              galleryId = settingObject.galleryId, neededSettings = _objectWithoutPropertiesLoose(settingObject, ["galleryId"]);
              host = 'VIEWER';
              settings = neededSettings ? neededSettings : {};
              data = {
                settings: settings,
                host: host,
                state: state
              };
              _context2.next = 7;
              return fetch(this.baseUrl + "/_api/app-settings-service/v1/settings/components/" + this.getCompId(), {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: this.getInstance()
                },
                body: JSON.stringify(data)
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function setMultiple(_x3, _x4) {
      return _setMultiple.apply(this, arguments);
    }

    return setMultiple;
  }();

  _proto.set = function set(key, value) {
    var _this$setMultiple;

    this.setMultiple((_this$setMultiple = {}, _this$setMultiple[key] = value, _this$setMultiple));
  };

  return AppSettings;
}();

export default AppSettings;